/**
 * Copyright 2026 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */

import React from "react";
import { Button } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";

const AlertButton = ({ label, onClick }) => (
    <Button
      endIcon={<NotificationsIcon sx={{ fontSize: 16 }} />}
      onClick={onClick}
      color="warning"
      variant="outlined"
      size="large"
      sx={{ borderRadius: 92 }}
    >
      {label}
    </Button>
  );

export default AlertButton;
